import { getCategoryByPath, SERVICE_CATEGORIES } from './serviceCategories';

export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://salonlev.ru').replace(/\/$/, '');

export const SITE_NAME = 'Л.Е.В. — Салон мужской эстетики';

export const SITE_ADDRESS = {
    streetAddress: 'Смоленский бульвар, 22/14',
    addressLocality: 'Москва',
    postalCode: '119002',
    addressCountry: 'RU',
};

export const SITE_GEO = {
    latitude: 55.743028,
    longitude: 37.583661,
};

export const SITE_AGGREGATE_RATING = {
    ratingValue: '5.0',
    reviewCount: '100',
    bestRating: '5',
    worstRating: '1',
    source: 'Яндекс',
};

export const SITE_METRO_NEARBY = ['Смоленская', 'Парк культуры', 'Арбат', 'Хамовники'];

export const SITE_GEO_AREA_TEXT =
    'Салон на Смоленском бульваре, рядом с метро Смоленская. Удобно добраться с Арбата, Парка культуры и из Хамовников.';

export const DEFAULT_DESCRIPTION =
    'Барбершоп полного цикла у м. Смоленская: стрижка, борода, уход за лицом. Рейтинг 5.0, запись онлайн 24/7.';

export const HOME_TITLE =
    'Л.Е.В. — барбершоп у метро Смоленская | стрижки, борода, брови';

export const BLOG_LIST_TITLE = 'Блог Л.Е.В. — статьи о мужском стиле и уходе';

export const BLOG_LIST_DESCRIPTION =
    'Советы барберов Л.Е.В.: стрижки, борода, уход за лицом и волосами. Экспертные статьи о мужской эстетике.';

export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const HOME_KEYWORDS =
    'мужской салон Москва, салон у метро Смоленская, барбершоп Смоленский бульвар, мужская стрижка Арбат, стрижка бороды Хамовники, барбершоп Парк культуры, мужской бровист, маникюр мужской, салон мужской эстетики, Л.Е.В.';

export const PAGE_META = {
    '/': {
        title: HOME_TITLE,
        description: DEFAULT_DESCRIPTION,
        keywords: HOME_KEYWORDS,
    },
    '/blog': {
        title: BLOG_LIST_TITLE,
        description: BLOG_LIST_DESCRIPTION,
    },
    '/offer': {
        title: `Публичная оферта | ${SITE_NAME}`,
        description:
            'Публичная оферта на оказание услуг салона мужской эстетики Л.Е.В. в Москве: условия записи, оплаты и оказания услуг.',
    },
    '/privacy': {
        title: `Политика конфиденциальности | ${SITE_NAME}`,
        description:
            'Политика конфиденциальности salonlev.ru: порядок обработки персональных данных пользователей сайта салона Л.Е.В.',
    },
    '/agreement': {
        title: `Пользовательское соглашение | ${SITE_NAME}`,
        description:
            'Пользовательское соглашение сайта салона мужской эстетики Л.Е.В.: правила использования сайта и сервисов.',
    },
    '/cookies': {
        title: `Соглашение об использовании cookies | ${SITE_NAME}`,
        description:
            'Соглашение об использовании файлов cookies на сайте salonlev.ru салона мужской эстетики Л.Е.В.',
    },
};

Object.values(SERVICE_CATEGORIES).forEach((category) => {
    PAGE_META[category.path] = {
        title: category.title,
        description: category.description,
        keywords: category.keywords,
    };
});

export const buildCanonical = (path) => {
    if (!path || path === '/') return `${SITE_URL}/`;
    const withLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const normalized =
        withLeadingSlash.length > 1 ? withLeadingSlash.replace(/\/+$/, '') : withLeadingSlash;
    return `${SITE_URL}${normalized}`;
};

export const BLOG_ARTICLE_SUFFIX = ' — блог Л.Е.В.';

export const buildArticleTitle = (title) => `${title}${BLOG_ARTICLE_SUFFIX}`;

export const getPageMeta = (pathname) => {
    const normalizedPath =
        pathname && pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

    if (PAGE_META[normalizedPath]) {
        return { ...PAGE_META[normalizedPath], canonicalPath: normalizedPath };
    }

    const category = getCategoryByPath(normalizedPath);
    if (category) {
        return {
            title: category.title,
            description: category.description,
            keywords: category.keywords,
            canonicalPath: normalizedPath,
        };
    }

    return { ...PAGE_META['/'], canonicalPath: '/' };
};
